import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import type { CustomizeService } from '../customize-service';
import { SkillApiService } from '../../apis/skill-api';
import { McpApiService } from '../../apis/mcp-api';
import type {
    WebSkillListParams,
    WebSkillCreateRequest,
} from '../../types';

@injectable()
export class CustomizeServiceImpl implements CustomizeService {
    constructor(
        @inject(SkillApiService) private skillApi: SkillApiService,
        @inject(McpApiService) private mcpApi: McpApiService
    ) {}

    getSkillList(params?: WebSkillListParams) {
        return this.skillApi.getList(params);
    }

    getSkillDetail(name: string) {
        return this.skillApi.getDetail(name);
    }

    createSkill(data: WebSkillCreateRequest) {
        return this.skillApi.create(data);
    }

    enableSkill(name: string) {
        return this.skillApi.enable(name);
    }

    disableSkill(name: string) {
        return this.skillApi.disable(name);
    }

    deleteSkill(name: string) {
        return this.skillApi.remove(name);
    }

    getMcpList() {
        return this.mcpApi.getList();
    }

    getMcpDetail(name: string) {
        return this.mcpApi.getDetail(name);
    }

    enableMcp(name: string) {
        return this.mcpApi.enable(name);
    }

    disableMcp(name: string) {
        return this.mcpApi.disable(name);
    }
}
